import { api } from '../boot/axios'

export default class BaseService {
  constructor(baseURL) {
    this.baseURL = baseURL
  }

  async getAll(params = {}) {
    const response = await api.get(this.baseURL, { params })
    return response.data
  }

  async getById(id) {
    const response = await api.get(`${this.baseURL}/${id}`)
    return response.data
  }

  async create(data) {
    const response = await api.post(this.baseURL, data)
    return response.data
  }

  async update(id, data) {
    const response = await api.put(`${this.baseURL}/${id}`, data)
    return response.data
  }

  async delete(id) {
    const response = await api.delete(`${this.baseURL}/${id}`)
    return response.data
  }

  // Method for updating singleton resources
  async singletonUpdate(data) {
    const response = await api.post(this.baseURL, data)
    return response.data
  }

  // Custom method for handling specific endpoints
  async customRequest(method, endpoint, data = null, config = {}) {
    const url = `${this.baseURL}${endpoint}`
    const normalizedMethod = String(method || 'get').toLowerCase()
    const queryOnlyMethods = new Set(['get', 'delete', 'head', 'options'])
    try {
      const requestConfig = {
        method: normalizedMethod,
        url,
        ...config
      }

      // Treat the third argument as query params for query-only methods.
      // This preserves the common calling pattern customRequest('get', '/x', { foo: 1 }).
      if (queryOnlyMethods.has(normalizedMethod)) {
        if (data != null && requestConfig.params === undefined) {
          requestConfig.params = data
        }
      } else if (data != null) {
        requestConfig.data = data
        // Axios defaults to application/json; that makes transformRequest stringify FormData and breaks file uploads.
        if (typeof FormData !== 'undefined' && data instanceof FormData) {
          requestConfig.headers = {
            ...(requestConfig.headers && typeof requestConfig.headers === 'object'
              ? requestConfig.headers
              : {}),
            'Content-Type': 'multipart/form-data'
          }
        }
      }

      // console.log(`Making ${method} request to ${url} with data:`, data, 'and config:', config)
      const response = await api(requestConfig)
      // console.log('Response received:', response)
      return response?.data
    } catch (error) {
      // Avoid console noise when offline or when global toast handling is sufficient.
      const offline = error?.isOffline || (typeof navigator !== 'undefined' && navigator.onLine === false && !error?.response)
      const silent = !!(config?.meta?.silent)
      if (!offline && !silent && import.meta.env.QUASAR_DEV) {
        console.error(`Error in customRequest (${method} ${url}):`, error)
      }
      throw error
    }
  }
}
